import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationSummary } from './verification-summary/verification-summary';
import { VerificationForm } from './verification-form/verification-form';
import { VerificationList } from './verification-list/verification-list';
import { AuditList } from './audit-list/audit-list';
import { CanonForm } from './canon-form/canon-form';
import { CanonList } from './canon-list/canon-list';
import { VerificationHistory } from './verification-history/verification-history';
import { VerificationHistoryDetails } from './verification-history-details/verification-history-details';

const routes: Routes = [
  {
    path: "verification-summary",
    component: VerificationSummary
  },
  {
    path: "verification-form",
    component: VerificationForm
  },
  {
    path: "verification-list",
    component: VerificationList
  },
  {
    path: "audit-queue",
    component: AuditList
  },
  {
    path: "canon-form",
    component: CanonForm
  },
  {
    path: "canon-list",
    component: CanonList
  },
  {
    path: "verification-history",
    component: VerificationHistory
  },
  {
    path: "verification-history-details",
    component: VerificationHistoryDetails
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationRoutingModule {

}
